module.exports = __webpack_public_path__ + "media/stylesheets/images/userway_logo_images/kylie-cosmetics-56fc7be67887f15050b35660281e5702.png";